module.exports = __webpack_public_path__ + "static/media/seven.9518aeed.mp3";